export default __webpack_public_path__ + "static/signage3-5f758cd85ddda4da70506ab2e969bb0d.webp";